import { getMediaDeliveryBaseUrl } from "./media-delivery-url";

const demoVideoBaseUrl = `${getMediaDeliveryBaseUrl()}/assets/video/demo`;

function normalizeDemoVideoFileName(fileName: string) {
  return fileName.replace(/^\/+/, "").replace(/^videos\//u, "");
}

export function resolveDemoVideoUrl(fileName: string) {
  const normalizedFileName = normalizeDemoVideoFileName(fileName);

  return `${demoVideoBaseUrl}/${normalizedFileName}`;
}

export function resolveDemoVideoPosterUrl(fileName: string) {
  const normalizedFileName = normalizeDemoVideoFileName(fileName);
  return `/images/demo-posters/${normalizedFileName.replace(/\.mp4$/iu, ".jpg")}`;
}
